import {
  Maybe,
  CalendarDateInput,
  Operation,
} from '../../../__generated__/globalTypes'

import {
  DetailedContactFragment,
  detailedContactFragmentString,
} from '../../fragments/__generated__/DetailedContactFragment'

import { calendarDateFragmentString } from '../../fragments/__generated__/CalendarDateFragment'

import { contactFragmentString } from '../../fragments/__generated__/ContactFragment'

import { relatedContactFragmentString } from '../../fragments/__generated__/RelatedContactFragment'

import { noteFragmentString } from '../../fragments/__generated__/NoteFragment'

import updateNoteRawString from '../UpdateNote.graphql'

const updateNoteString = [
  updateNoteRawString,
  detailedContactFragmentString,
  calendarDateFragmentString,
  contactFragmentString,
  relatedContactFragmentString,
  noteFragmentString,
].join('\n\n')

export type UpdateNoteData = {
  updateNote: {
    contact: DetailedContactFragment
  }
}

export type UpdateNoteVariables = {
  id: string
  text: string
  date?: Maybe<CalendarDateInput>
}

export type UpdateNote = Operation<UpdateNoteData, UpdateNoteVariables>

export const UpdateNote = ({
  id,
  text,
  date,
}: UpdateNoteVariables): UpdateNote => ({
  query: updateNoteString,
  variables: {
    id,
    text,
    date: date && CalendarDateInput(date),
  },
})
